import { dealSearchSagaWatcher } from 'shared/components/autocomplete/deals/sagas';
import { jobNumberSearchSagaWatcher } from 'shared/components/autocomplete/jobNumbers/sagas';

export const autocompleteSearchSagas = [
    dealSearchSagaWatcher,
    jobNumberSearchSagaWatcher,
];
